export default function useMedia() {
  const basePath = process.env.PUBLIC_URL || "";

  return {
    getIconUrl: (fileName) => `${basePath}/assets/icons/${fileName}`
  };
}
